import { Box, Typography, Button, Container } from "@mui/material";
import { productCategories } from "../../data/productCategories";
import { Link } from "react-router-dom";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

const cardStyle = {
  width: "100%",
  maxWidth: 340,
  borderRadius: "18px",
  overflow: "hidden",
  background: "#fff",
  boxShadow: "0 8px 28px rgba(0,0,0,0.08)",
  transition: "0.3s",
  cursor: "pointer",
  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: "0 14px 40px rgba(0,0,0,0.18)",
  },
};

export default function ProductCategories() {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{ mb: 1, color: "#1a237e" }}
        >
          Product Categories
        </Typography>

        <Box
          sx={{
            width: "70px",
            height: "4px",
            background: brandRed,
            borderRadius: 2,
            mb: 4,
          }}
        />

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 3,
            justifyContent: { xs: "center", md: "flex-start" },
          }}
        >
          {productCategories.map((cat) => (
            <Box key={cat.id} sx={cardStyle}>
              {/* <img
                src={cat.images[0]}
                width="100%"
                height="200"
                style={{ objectFit: "cover" }}
                alt={cat.title}
              /> */}

              <Box sx={{ p: 2 }}>
                <Typography fontWeight={700} sx={{ fontSize: "1.05rem" }}>
                  {cat.title}
                </Typography>

                <Typography
                  sx={{ mt: 1, mb: 2, fontSize: ".9rem", color: "gray" }}
                >
                  {cat.shortDesc}
                  {/* {cat.shortDesc.substring(0, 80)}... */}
                </Typography>

                {/* <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#d50000",
                    borderRadius: "10px",
                    textTransform: "none",
                    "&:hover": { bgcolor: "#b00000", color: "#fff" },
                  }}
                  component={Link}
                  to={`/products/${cat.id}`}
                >
                  View More
                </Button> */}
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
